import { FindingsAlert, FindingsSelector } from '@app/icare/components/findings'
import { selectByFindingId } from '@app/icare/entities/patient/queries/patientFindingsQueryOptions'
import { PatientAddressTypeEnum } from '@app/icare/entities/patient/schema/PatientAddress'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { entityParams } from '@pkg/db/utils'
import { createFileRoute } from '@tanstack/react-router'
import { Flex } from 'antd'
import { AddressTable } from './-components/AddressTable'

export const Route = createFileRoute('/_app/patienten/$id/_edit/stammdaten/lieferadressen')({
  component: RouteComponent,
  params: entityParams({ id: PatientId }),
})

function RouteComponent() {
  const { id } = Route.useParams()
  return (
    <Flex vertical gap="small">
      <FindingsSelector
        selector={selectByFindingId('AddressesDeliveryIncomplete')}
        children={f => <FindingsAlert findings={f} />}
      />
      <AddressTable addressType={PatientAddressTypeEnum.delivery} patientId={id} />
    </Flex>
  )
}
